import { styles as commonStyles } from '../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
export const templateIntuneSensor = document.createElement('template');

templateIntuneSensor.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
    <gz-form-field  class="sensor-select-wrapper mb-2">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">
        <gz-form-field label="" id="intune_application_id" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="intune_tenant_id" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="intune_client_secret" required stacked>
        <gz-input gz-form-input="" type="password" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
